import React from "react";
import { Grid, Typography } from "@material-ui/core";
import EditText from "../../components/EditText";
import { useTranslation } from "react-i18next";

const PasswordView = (props) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color="textPrimary" variant="h5">
          {t("profile.change_password.title")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("profile.change_password.current_password")}
          name="password"
          type="password"
        />
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("profile.change_password.new_password")}
          name="new_password"
          type="password"
        />
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("profile.change_password.confirm_password")}
          name="confirm_password"
          type="password"
        />
      </Grid>
    </Grid>
  );
};

export default PasswordView;
